export const REMARK_ACTIONS = {
  CREATED: 'createRemark',
  EDITED: 'editRemark',
  DESTROYED: 'destroyRemark',
}

export const numberOfNamesShown = 2

export const removeTodoPeriodScopes = {
  CURRENT: 'current',
  CURRENT_AND_FOLLOWING: 'current_and_following',
  FOLLOWING: 'following',
}
